'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mixChild = require('../utils/mix-child.js');

exports.default = {
  mixins: [(0, _mixChild.mixChild)('dof-row')],
  computed: {
    gap: function gap() {
      return this.parent && this.parent.gap || 16;
    },
    style: function style() {
      var res = {};
      // console.log('this.parent.gap')
      var constGap = this.parent && this.parent.gap || 20;
      if (!this.isLast) {
        res.marginRight = constGap + 'px';
      }
      return res;
    }
  }
}; //
//
//
//
//
//


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-col/index.vue
// module id = 323
// module chunks = 0 1